export default __webpack_public_path__ + "static/media/regulamento.87cf9630.svg";